import { useMenuStore } from "@/store/menu";
import { useProductsStore } from "@/store/products";

export const containerMenuProps = () => ({
  isHomePage: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useContainerMenu = () => {

  const { categories } = storeToRefs(useMenuStore());
  const { breadcrumbs } = storeToRefs(useProductsStore());

  const activeCategoryId = computed(() => {
    if (breadcrumbs.value && breadcrumbs.value.length > 0) {
      return breadcrumbs.value[0].id;
    }
    return null;
  })
  const activeCategory = computed(() => {
    if (activeCategoryId.value) {
      return categories.value.find((cat) => {
        return cat.id.includes(activeCategoryId.value);
      });
    }
    return null;
  })

  return {
    categories,
    breadcrumbs,
    activeCategoryId,
    activeCategory
  }
}